import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { TextInput } from "react-native-gesture-handler";
import { globalStyles } from "../../styles/globalStyles";
import { useState } from "react";

export default function FilterRecommendations({ setFilteredBooks, books }) {
  const [locationFilter, setLocationFilter] = useState(false);
  const [search, setSearch] = useState();
  const [showTitle, setShowTitle] = useState(false);

  function filterBooks() {
    let favoriteBooks = [];
    books.map((book) => {
      const bookreviews = book.reviews.items;
      bookreviews.map((review) => {
        const reviewer = review.reviewer.userName;
        if (reviewer.toLowerCase() === search.toLowerCase() && review.favorite)
          favoriteBooks.push(book);
      });
    });
    setFilteredBooks(favoriteBooks);
    setShowTitle(true);
  }
  return (
    <View>
      <View style={{ marginLeft: 10 }}>
        {locationFilter ? (
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <MaterialIcons
              name="close"
              color="#A48578"
              size={24}
              onPress={() => {
                setLocationFilter(false);
                setFilteredBooks(books);
                setShowTitle(false);
              }}
              style={{ marginTop: 5, marginRight: 5 }}
            />
            <TextInput
              style={{
                ...globalStyles.input,
                paddingVertical: 10,
                fontSize: 17,
                color: "#56494c",
                marginLeft: 0,
                borderColor: "#56494c",
                marginTop: 10,
              }}
              placeholder="Search Users"
              placeholderTextColor="#A48578"
              onChangeText={(text) => {
                setSearch(text);
                setShowTitle(false);
              }}
            />
            <TouchableOpacity
              onPress={() => {
                filterBooks();
              }}
            >
              <Text
                style={{
                  ...globalStyles.paragraph,
                  fontFamily: "quicksand-bold",
                  marginTop: 15,
                  fontSize: 19,
                  marginLeft: -2,
                }}
              >
                SEARCH
              </Text>
            </TouchableOpacity>
          </View>
        ) : (
          <View style={{ flexDirection: "column", alignItems: "center" }}>
            <MaterialIcons
              name="filter-list"
              color="#56494c"
              size={30}
              style={{ marginBottom: -5 }}
              onPress={() => {
                setLocationFilter(true);
              }}
            />
            <Text
              style={{
                marginBottom: 5,
                fontFamily: "quicksand-normal",
                color: "#56494c",
              }}
            >
              filter recs
            </Text>
          </View>
        )}
      </View>
      {showTitle && (
        <View style={styles.viewStyle}>
          <Text style={styles.captionStyle}>
            {"SHOWING FAVORITES FOR " + search.toUpperCase()}
          </Text>
        </View>
      )}
    </View>
  );
}

const styles = new StyleSheet.create({
  captionStyle: {
    ...globalStyles.subtitleText,
    fontSize: 17,
    fontFamily: "quicksand-bold",
    marginTop: 5,
  },
  viewStyle: {
    backgroundColor: "white",
    shadowColor: "black",
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: "50%",
    shadowRadius: 2,
    borderRadius: 20,
    marginBottom: 10,
    paddingVertical: 10,
    marginTop: 10,
  },
});
